import { atomWithStorage } from "jotai/utils";

export type TerminalCommandType = "shell" | "amp" | "claude" | "codex" | "copilot" | "gemini";

export const $selectedTerminalCommand = atomWithStorage<TerminalCommandType>(
	"moment:terminal-command",
	"shell"
);
$selectedTerminalCommand.debugLabel = "selectedTerminalCommand";
